import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import { StyledText } from '..'

const GroupHeader = ({ title, showTitle, specialEvent }) => (
  <header className={showTitle ? '' : 'noTitle'}>
    <StyledText el="h2" className="display1">
      {specialEvent ? 'Hero Image' : title}
    </StyledText>
    <style jsx>{styles}</style>
  </header>
)

GroupHeader.propTypes = {
  title: PropTypes.string,
  showTitle: PropTypes.bool,
  specialEvent: PropTypes.bool,
}

GroupHeader.defaultProps = {
  title: '',
  showTitle: false,
  specialEvent: false,
}

export default GroupHeader
